import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCepEdit from './CepEdit.hook';
import { buttonStyle, headerWrapperStyle } from './CepEdit.styles';
import { mayaCepListRoute } from 'basics/constants/routes.constants';
import { VeevaSyncStatus } from 'basics/enums/maya.enums';
import CepForm from 'components/CepForm/CepForm';
import { FormLayoutMidPanelContent } from 'components/FormLayout';
import Heading from 'components/Heading';
import MayaLayout from 'components/MayaLayout';
import VeevaStatusBar from 'components/VeevaStatusBar/VeevaStatusBar';
import { ActionButton, ButtonVariant } from 'yoda-ui/components/BiogenLincDS/Buttons';
import Box from 'yoda-ui/components/Box';
import { Icons } from 'yoda-ui/components/Icons/Icon';

const CepEdit: FC = () => {
  const { t } = useTranslation();

  const {
    cepStateValue,
    submitCallback,
    navigate,
  } = useCepEdit();

  return (
    <MayaLayout>
      <FormLayoutMidPanelContent>
        <ActionButton
          label={ t('actions_back_label') }
          icon={ Icons.arrowBack }
          onClick={ () => { navigate(mayaCepListRoute); } }
          variant={ ButtonVariant.primary }
          sx={ buttonStyle }
        />
        <Box sx={ headerWrapperStyle }>
          <Heading>
            { t('maya_edit_cep_form_title') }
          </Heading>
          {
            cepStateValue
              ? (<VeevaStatusBar
                lastVeevaSync={ cepStateValue.cep?.lastVeevaSync }
                lastVeevaSyncErrors={ cepStateValue.cep?.globalCepSyncStatus?.errors }
                veevaSyncStatus={ cepStateValue.cep?.globalCepSyncStatus?.syncStatus as VeevaSyncStatus }
              />)
              : null
          }
        </Box>
      </FormLayoutMidPanelContent>
      <CepForm submitCallback={ submitCallback } isTemplate={ false }/>
    </MayaLayout>
  );
};

export default CepEdit;
